var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        ref: "surveyModal",
        staticClass: "modal fade",
        attrs: {
          id: "surveyModal",
          "data-bs-backdrop": "static",
          "data-bs-keyboard": "false",
          tabindex: "-1",
          "aria-labelledby": "surveyModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-dialog modal-dialog-centered modal-dialog-scrollable",
          },
          [
            _vm.loaded
              ? _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "surveyModalLabel" },
                      },
                      [_vm._v(_vm._s(_vm.survey.title))]
                    ),
                    _vm._v(" "),
                    _c("button", {
                      staticClass: "btn-close",
                      attrs: {
                        type: "button",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close",
                      },
                      on: { click: _vm.postpone },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-body" },
                    [
                      _c("div", {
                        staticClass: "mb-3",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.snarkdown(_vm.survey.description)
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.survey.questions, function (question) {
                        return _c(
                          "div",
                          { key: _vm.kebabCase(question.title) },
                          [
                            _c("SurveyQuestion", {
                              attrs: {
                                question: question,
                                hasError: _vm.validationProblems.includes(
                                  _vm.kebabCase(question.title)
                                ),
                              },
                              model: {
                                value: question.value,
                                callback: function ($$v) {
                                  _vm.$set(question, "value", $$v)
                                },
                                expression: "question.value",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.showError
                        ? _c("div", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("translate")(
                                    "Validation errors. Please check if all the fields are correct."
                                  )
                                ) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "modal-footer d-flex justify-content-between",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link text-muted btn-sm",
                          attrs: { type: "button", "data-bs-dismiss": "modal" },
                          on: { click: _vm.postpone },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("translate")("Remind me later")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-dark btn-sm px-3",
                          attrs: { type: "button" },
                          on: { click: _vm.submit },
                        },
                        [_vm._v(_vm._s(_vm._f("translate")("Submit")))]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }